import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const SymbolCard = (props) => {
    const { symbol, orientation, textStyle } = props;
    return (
        <Card sx={{ minWidth: 275 }}>
            <CardContent>
                <Typography
                    variant={textStyle}
                    component="div"
                    textTransform={{ rotate: orientation }}
                >
                    {symbol}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default SymbolCard;
